<template>
	<div class="container">
		<div class="wrapper">
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item :to="{ path: '/store' }">软件商店</el-breadcrumb-item>
			  <el-breadcrumb-item >{{data.typeName}}</el-breadcrumb-item>
			  <el-breadcrumb-item>{{typeName}}</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="classify-desc">
				<div class="title">{{data.typeName}}</div>
				<div class="abstrc">{{data.summary}}</div>
			</div>
			<div>
				<div class="soft-wrapper">
					<div class="classify">
						<div class="classify-item" v-for="item in data.children" :class="{'actived':item.id == typeId}" @click="handleType(item)">{{item.typeName}}</div>
					</div>
					<div class="soft-item" v-for="item in dataList" @click="toDetail(item.id)">
						<div class="soft-msg">
							<div class="logo">
								<el-image :src="item.logo" fit="scale-down"></el-image>
							</div>
							<div>
								<div class="name">{{item.name}}</div>
								<div class="rate"><el-rate v-model="value" disabled show-score text-color="#ff9900" score-template="{value}"></el-rate></div>
							</div>
							<div class="btn">
								<span class="guanzhu-btn" @click.stop="item.isCollect?cancleSoftCollect(item.id):collect(item.id)"><i class="iconfont" :class="item.isCollect?'icon-31guanzhu1xuanzhong':'icon-31guanzhu1'"></i>{{item.isCollect?'取消收藏':'收藏'}}</span>
								<el-button type="warning" size="mini" round  @click.stop="">咨询产品</el-button>
							</div>
						</div>
						<div class="desc" style="-webkit-box-orient: vertical; white-space:pre-line;">{{item.baseInfo}}</div>
						<div class="soft-image">
							<el-image v-for="(val,index) in item.images.split(',')" :style="{'display':index>=3?'none':'inline-block'}" :src="val" fit="cover"></el-image>
						</div>
						
					</div>
					<el-pagination
						:hide-on-single-page="true"
					    layout="prev, pager, next"
						@current-change="handleCurrentChange"
					    :total="total">
					  </el-pagination>
					  <el-empty v-if="total == 0" :image-size="200"></el-empty>
				</div>
				<!-- 右侧侧边栏 -->
				<div class="sidebar">
					<div class="side-item">
						<div class="release-title">还是不知道如何选择产品？没找到合适的产品？</div>
						<el-input class="input-key" placeholder="请输入您的姓名" size="small" v-model="data.name"></el-input>
						<el-input class="input-key" placeholder="请输入您的手机号" size="small" v-model="data.mobile"></el-input>
						<el-button class="release-btn" type="warning" size="medium">提交</el-button>
					</div>
					
					<div class="side-item">
						<div class="title">公众号</div>
						<el-image class="qrcode" :src="require('@/assets/qrcode.jpg')" fit="contain"></el-image>
						<div class="tips">关注微信公众号，订阅每周资讯</div>
					</div>
					<div class="active-image">
						<el-image :src="require('@/assets/activity-image.png')" fit="contain">
							<div slot="error" class="image-slot">
								<i class="el-icon-picture-outline"></i>
							</div>
						</el-image>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getType, getSoftList,softCollect } from '@/api/software/index'
import { toLogin } from '@/api/isLogin'
import { cancleCollect } from '@/api/social/index'
import { getIsTrial, getToken } from '@/utils/auth'
export default {
  data () {
    return {
	  value: 4.5,
	  dataList:[],
	  typeId: '',
	  typeName: '全部',
	  page:1,
	  total: 0,
	  softType: {},
      data:{
		  name: '',
		  mobile: ''
      }
    }
  },
  methods: {
    async getData(){
    	const res = await getSoftList({page:this.page,limit:10,isSoftware:1,typeId:this.typeId,conSub: this.typeId==this.data.id?1:0})
    	if (res.code === 0) {
			this.dataList = res.data.list
			this.total = res.data.total
    	} else {
    	  this.$message.error(res.msg)
    	}
    },
	handleCurrentChange(val){
		this.page = val
		this.getData()
	},
	handleType(item){
		localStorage.setItem('softType', JSON.stringify({parentId:this.data.id,parentName:this.data.typeName,typeId:item.id,typeName:item.typeName}))
		this.typeId = item.id
		this.typeName = item.typeName
		this.getData()
	},
	async getTypeList(id){
		const res = await getType({parentId:id})
		if (res.code === 0) {
			this.data = res.data.list[0]
			this.data.children.unshift({"id": id,"typeName": "全部","parentId": id})
			this.getData()
		} else {
		  this.$message.error(res.msg)
		}
	},
	async collect(id){
		if(getToken()){
			const res = await softCollect({dataId:id,type:'1'})
			if (res.code === 0) {
				this.$message.success('收藏成功')
				this.getData()
			} else {
			  this.$message.error(res.msg)
			}
		}else{
			toLogin(this)
		}
		
	},
	async cancleSoftCollect(id){
		if(getToken()){
			const res = await cancleCollect({dataId:id})
			if (res.code === 0) {
				 this.$message({
				  message: '已取消收藏',
				  type: 'success'
				});
				this.getData()
			} else {
			  this.$message.error(res.msg)
			}
		}else{
			toLogin(this)
		}
		
		
	},
	toDetail(id){
		this.$router.push({name:'soft-detail',params:{id:id}})
	}
  },
  mounted () {
	this.typeId = this.$route.params.typeId
	this.parentId = this.$route.params.parentId
	this.getTypeList(this.parentId)
  }

}
</script>

<style lang="scss" scoped>
.container{
	background-color: #e7e7e7;
	margin-top: 80px;
	padding-bottom: 10px;
	.wrapper{
		max-width: 1400px;
		width: 80vw;
		margin: 0 auto;
		/deep/.el-breadcrumb{
			font-size: 16px;
			margin: 30px 0;
			padding-top: 30px;
		}
		/deep/.el-breadcrumb__inner a,
		/deep/.el-breadcrumb__inner.is-link{
			font-weight: 500;
		}
		/deep/.el-breadcrumb__inner a:hover, 
		/deep/.el-breadcrumb__inner.is-link:hover{
			color: #FF842E;
		}
		/deep/.el-empty{
			background-color: #fff;
			margin-top: 10px;
			border-radius: 10px;
		}
		.classify-desc{
			background-color: #fff;
			border-radius: 8px;
			padding: 20px;
			.title{
				color: #383838;
				font-size: 20px;
				font-weight: 800;
			}
			.abstrc{
				color: #6D6D6D;
				margin: 10px 0;
			}
		}
	}
	/deep/.el-pager li.active {
	    color: #FF842E;
	    cursor: default;
	}
	/deep/.el-pager li:hover {
	    color: #FF842E;
	}
	/deep/.el-pagination button:hover{
		color: #FF842E;
	}
	/deep/.el-image__error{
		height: 100px;
	}
	/deep/.el-pagination{
		text-align: center;
		margin: 30px 0 20px;
	}
	/deep/.el-pagination .btn-next,
	/deep/.el-pagination .btn-prev,
	/deep/.el-pager li{
		background: unset;
	}
	/deep/.el-input.is-active .el-input__inner,
	/deep/.el-input__inner:focus{
		border-color: #C0C4CC;
	}
	.soft-wrapper{
		margin-top: 15px;
		display: inline-block;
		width: calc(100% - 300px);
		.classify{
			background-color: #fff;
			border-radius: 8px;
			padding: 15px 20px;
			white-space: nowrap;
			overflow-x: scroll;
			&::-webkit-scrollbar {
			    width: 6px;
			    height: 6px;
			}
			&::-webkit-scrollbar-thumb {
			    background-color: silver;
			    border-radius: 3px;
			}
			&::-webkit-scrollbar-track {
			    background-color: #f1f1f1;
			}
			.classify-item{
				display: inline-block;
				margin-right: 15px;
				cursor: pointer;
				&:last-child{
					margin: 0;
				}
				&.actived{
					color: #FF8632;
				}
			}
		}
		.soft-item{
			background-color: #fff;
			border-radius: 8px;
			padding: 15px 20px;
			margin-top: 15px;
			cursor: pointer;
			.soft-msg{
				&>div{
					display: inline-block;
					vertical-align: top;
				}
				.logo{
					.el-image{
						width: 70px;
						height: 70px;
						border-radius: 8px;
					}
					margin-right: 20px;
				}
				.name{
					font-size: 18px;
					font-weight: 800;
					color: #3A404E;
					margin: 5px 0;
				}
				.rate{
					margin: 10px 0;
				}
				.btn{
					float: right;
					.guanzhu-btn{
						margin-right: 20px;
						font-size: 16px;
						display: inline-block;
						vertical-align: middle;
						cursor: pointer;
						.iconfont{
							margin-right: 5px;
							font-size: 18px;
						}
						.icon-31guanzhu1xuanzhong{
							color: #FF440E;
						}
					}
					
					.el-button--warning{
						background-color: #FF842E;
					}
				}
			}
			.desc{
				color: #6D6D6D;
				font-size: 16px;
				overflow: hidden;
				display: -webkit-box;
				-webkit-line-clamp: 3;
				-webkit-box-orient: vertical;
				text-overflow: ellipsis;
				white-space: normal;
			}
			.soft-image{
				margin: 10px 0;
				border-top: 1px solid #CFCFCF;
				padding: 10px 0;
				display: flex;
				flex-wrap: wrap;
				gap: 10px;
				.el-image{
					flex: 0 0 calc(33% - 20px);
					/* width: 180px;*/
					height: 150px; 
					margin-right: 10px;
					border-radius: 8px;
				}
			}
		}
	}
	.sidebar{
		display: inline-block;
		vertical-align: top;
		margin-top: 15px;
		.active-image{
			.el-image{
				width: 270px;
				margin: 0 0 30px 30px;
				
			}
		}
		.side-item{
			width: 270px;
			box-sizing: border-box;
			padding: 24px;
			margin: 0 0 30px 30px;
			border-radius: 15px;
			box-shadow: 0 0 15px rgba(0,0,0, .05);
			background-color: #fff;
			.release-title{
				font-size: 18px;
				font-weight: 800;
				text-align: center;
				margin-bottom: 10px;
			}
			.el-input{
				margin-top: 10px;
				/deep/.el-input__inner{
					border-radius: 20px;
					padding-left: 25px;
				}
				
			}
			.release-btn{
				background-color: #FF842E;
				width: 100%;
				border-radius: 20px;
				margin-top: 20px;
			}
			
			.title{
				font-size: 18px;
				font-weight: 800;
				color: #2B2B2B;
				margin-bottom: 15px;
			}
			.qrcode{
				margin: 20px auto;
				width: 80%;
				display: block;
			}
			.tips{
				font-size: 14px;
				color: #525254;
				text-align: center;
			}
			
			
		}
	}
}

</style>